import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class RegimenFiscal extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'fiscal-regimen/one', saveUrl: 'fiscal-regimen/save', backUrl: '/Catalogo/CfdiFiscalRegimenes' },
      new Form([
        Form.Field('text', 'cfdi_regimen_clave', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'cfdi_regimen_nombre', 'Nombre', '', [Validators.required], 8),
      ], ['Guardar'], 'Regimen Fiscal'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(RegimenFiscal)
